/*
import './App.css';
import { TVChartContainer } from './components/TVChartContainer/index';
import { version } from './charting_library';

const App = () => {
	return (
		<div className={'App'}>
			<header className={'App-header'}>
				<h1 className={'App-title'}>
					TradingView Charting Library and React Integration Example {version()}
				</h1>
			</header>
			<TVChartContainer />
		</div>
	);
}

export default App;
*/


import './App.css';
import { TVChartContainer } from './components/TVChartContainer/index';
import { version } from './charting_library';
import React, {useState, Component} from 'react';
import Header from './components/Header/Header';
import LoginForm from './components/LoginForm/LoginForm';
import RegistrationForm from './components/RegistrationForm/RegistrationForm';
import Home from './components/Home/Home';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import AlertComponent from './components/AlertComponent/AlertComponent'; 
import NotAuthPage from './components/NotAuthPage/NotAuthPage';


function App(props) {
  const [title, updateTitle] = useState(null);
  const [errorMessage, updateErrorMessage] = useState(null);
  // Dichiara una nuova variable di stato, che chiameremo "userLogged"  
  const [userLogged, updateUserLogged] = useState(sessionStorage.getItem('userLogged') || null);
  
  
  return (
    <Router>
      <div className="App">
        <Header title={title}/>
          <div className="container-fluid align-items-center flex-column">

            <Switch>
              <Route path="/" exact={true}>
                <div className="hv-center">
                  <LoginForm updateUserLogged={updateUserLogged} showError={updateErrorMessage} updateTitle={updateTitle}/>
                </div>
              </Route>
              <Route path="/register">
                <div className="hv-center">
                  <RegistrationForm showError={updateErrorMessage} updateTitle={updateTitle}/>
                </div>
              </Route>
              <Route path="/login">
                <div className="hv-center">
                  <LoginForm updateUserLogged={updateUserLogged} showError={updateErrorMessage} updateTitle={updateTitle}/>
                </div>
              </Route>
              {userLogged ? 
                  <Route path="/GianTrader">
                    <Home/>
                  </Route>
                : <NotAuthPage/>
              }
            </Switch>

            <AlertComponent errorMessage={errorMessage} hideError={updateErrorMessage}/>

          </div>
      </div>
    </Router>
  );
}

export default App;

